import React from "react";
import { GroupsContainer } from "./Groups.styled";

const Groups = () => {
  return (
    <GroupsContainer>
      <h2>User Groups</h2>
      <p>User groups information will be displayed here.</p>
    </GroupsContainer>
  );
};

export default Groups;

